import type { ReactNode } from 'react';

export const symbol_label_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m747-300-43-43 102-137-195-260H307l-60-60h364q14.25 0 27 6.37 12.75 6.38 21 17.63l195 260q12 15.68 12 35.84Q866-460 854-444L747-300Zm-607 80h489L140-709v489Zm0 60q-24.75 0-42.37-17.63Q80-195.25 80-220v-520q0-6.97 1.5-12.98Q83-759 85-764L7-842q-9-9-8.5-21T8-884q9-9 21-9t21 9L889-45q9 9 8.5 21t-9.89 20.87Q879 5 867 5t-21-8L660-184q-8 11-21 17.5t-27 6.5H140Zm245-305Zm172-77Z"
		/>
	</svg>
);
